import axios from 'axios';

/**
 * 获取移位校正记录
 */
export const getJitters = (params) => {
  return axios.get(`/api/jitters?deviceId=${params.deviceId}`);
};


/**
 * 创建移位校正记录
 */
export const createJitter = (params) => {
  const { deviceId, startJitterAt, endJitterAt, jitters } = params;
  return axios.post(`/api/devices/${deviceId}/jitters`, { startJitterAt, endJitterAt, jitters });
};


/**
 * 删除校正记录
 */
export const deleteJitter = (params) => {
  return axios.delete(`/api/jitters/${params.jitterId}`);
};

